<template>
  <div>
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane name="all">
        <span slot="label"><i class="tab-dot tab-dot--all"/>全部</span>
      </el-tab-pane>
      <el-tab-pane name="approved">
        <span slot="label"><i class="tab-dot tab-dot--approved"/>已审批</span>
      </el-tab-pane>
      <el-tab-pane name="unapproved">
        <span slot="label"><i class="tab-dot tab-dot--unapproved"/>未审批</span>
      </el-tab-pane>
    </el-tabs>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="salesForecasts"
        :column-width="130"
        :span-merge-keys="['customerName', 'customerNo', 'billNo', 'selection', 'action']"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <template v-if="activeTab === 'all'">
          <el-button v-if="limits.genAuth" type="primary" :loading="submitLoading" @click="selectDeliverBill">
            生成销售预测
          </el-button>
          <el-button v-if="limits.genAuth" type="primary" :loading="submitLoading" @click="submitToSap">
            提交SAP
          </el-button>
          <el-upload action="" :http-request="importFile" :show-file-list="false" style="float: left; margin-right: 4px;">
            <el-button type="primary" :loading="importLoading">导入模板</el-button>
          </el-upload>
          <el-button
              type="primary"
              plain
              icon="el-icon-download"
              style=" margin-left: 6px;"
              @click="downloadModel">
            模板下载
          </el-button>
        </template>
        <el-button
            v-if="limits.approvalAuth && activeTab === 'unapproved'"
            type="success"
            :loading="approvalLoading"
            :disabled="!selection || !selection.length"
            @click="openApproval">
          审批
        </el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
            <el-form-item label="审批状态">
              <el-select v-model="filter.status" clearable placeholder="请选择状态" @change="loadData(1)">
                <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="预测编号">
              <el-input v-model.trim="filter.billNo" placeholder="请输入预测编号" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="客户编号">
              <el-input v-model.trim="filter.customerNo" placeholder="请输入客户编号" clearable/>
            </el-form-item>
            <el-form-item label="销售员">
              <el-input v-model.trim="filter.salesPersonName" placeholder="请输入销售员" clearable/>
            </el-form-item>
            <el-form-item label="商务专员">
              <el-input v-model.trim="filter.businessPersonName" placeholder="请输入商务专员" clearable/>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
            <el-form-item label="预测起始日期">
              <el-date-picker
                  v-model="foreTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('foreTimeRange', 'foreTimeBegin', 'foreTimeEnd')"/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button type="success" :loading="submitLoading" @click="openAddDetail(scope.row)">
          新增明细
        </el-button>
      </template>
    </view-table>
    <sales-order-edit ref="salesOrderEdit" :options="options" @save-success="loadData"/>
    <sales-forecast-edit ref="salesForecastEdit" @save-success="loadData"/>
    <sap-delivery-edit ref="sapDeliveryEdt"/>
    <material-select ref="materialSelect" @select="onMaterialSelect"/>
    <approval-dialog ref="approvalDialog" @save-success="loadData"/>
  </div>
</template>

<script>
  import SalesOrderEdit from "@/views/SalesManage/SalesOrder/SalesOrderEdit";
  import ViewTable from "@/components/ViewTable";
  import SapDeliveryEdit from "@/views/SalesManage/DeliveryBll/SapDeliveryEdit";
  import SalesForecastEdit from "@/views/SalesManage/SalesForecast/SalesForecastEdit";
  import ApprovalDialog from "@/views/SalesManage/SalesForecast/approval-dialog";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "SalesForecastList",
    components: { SapDeliveryEdit, SalesOrderEdit, ViewTable, SalesForecastEdit, ApprovalDialog, MaterialSelect },
    data() {
      return {
        submitLoading: false,
        approvalLoading: false,
        activeTab: "all",
        selection: [],
        options: [],
        limits: {
          addAuth: this.$auth(354),
          editAuth: this.$auth(355),
          delAuth: this.$auth(356),
          subAuth: this.$auth(363),
          genAuth: this.$auth(365),
          creatDeliveryAuth: this.$auth(135),
          approvalAuth: this.$auth(133),
        },
        createTimeRange: [],
        foreTimeRange: [],
        filter: {
          billNo: "",
          customerNo: "",
          customerName: "",
          salesPersonName: "",
          businessPersonName: "",
          createTimeBegin: "",
          createTimeEnd: "",
          foreTimeBegin: "",
          foreTimeEnd: "",
          approveType: 0,
          status: "",
        },
        importLoading: false,
        // 状态选项（与后端 SalesForecastStatusDict 保持一致）
        statusOptions: [
          { label: "草稿", value: 0 },
          { label: "商务专员确认", value: 10 },
          { label: "主管及区总确认", value: 20 },
          { label: "总监确认", value: 30 },
          { label: "提交SAP", value: 40 },
        ],
        // 临时存放要添加明细的行
        addDetailTargetRow: null,
        // 物料选择过滤器（传给 MaterialSelect）
        materialFilter: { status: 10, priceStatus: 30 },
        columnsProperty: [
          {
            key: "billNo",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.salesForecastEdit.open(params.row, 0);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "action",
            width: 290,
            slot: "action",
            fixed: "right",
          },
          {
            key: "salesOrderPrice",
            align: "center",
            width: 120,
            render: (h, params) => {
              const val = params.row.salesOrderPrice;
              return h("span", val != null ? val.toFixed(2) : "-");
            },
          },
          {
            key: "materialNo",
            render: (h, params) => {
              const row = params.row || {};
              const groupTotal = row._groupTotal || (row._groupRowspan && row._groupRowspan > 0 ? row._groupRowspan : 1);
              // 用 inline-flex 容器保证物料编号与按钮同行显示
              const contentChildren = [];
              contentChildren.push(h("span", { style: { display: "inline-block" } }, row.materialNo || ""));
              if (groupTotal > 1) {
                contentChildren.push(
                  h(
                    "el-button",
                    {
                      props: { type: "text", size: "small" },
                      style: { color: "#F56C6C", marginLeft: "8px", padding: "0" },
                      on: {
                        click: (ev) => {
                          // 阻止行级点击或其他冒泡
                          if (ev && ev.stopPropagation) ev.stopPropagation();
                          this.deleteDetailHandle(row);
                        },
                      },
                    },
                    "删除",
                  ),
                );
              }
              return h("span", { style: { display: "inline-flex", alignItems: "center" } }, contentChildren);
            },
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      handleTabClick() {
        this.selection = [];
        if (this.activeTab === "all") {
          this.filter.approveType = 0;
        } else if (this.activeTab === "approved") {
          this.filter.approveType = 1;
        } else if (this.activeTab === "unapproved") {
          this.filter.approveType = 2;
        }
        this.loadData(1);
      },

      // 审批状态下拉框变化时，同步tab选中
      onApproveTypeChange(val) {
        if (val === 0) {
          this.activeTab = "all";
        } else if (val === 1) {
          this.activeTab = "approved";
        } else if (val === 2) {
          this.activeTab = "unapproved";
        }
        this.loadData(1);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        const approveType = this.filter.approveType;
        this.filter = Object.assign(this.filter, filter);
        this.filter.approveType = approveType;
      },

      addEditHandle(row) {
        this.$refs.salesForecastEdit.open(row, 1);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "salesForecasts", row.pkId)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("删除成功");
              this.loadData();
            }
          });
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "salesForecasts/importFile", formData).then((res) => {
          if (res.success) {
            this.importLoading = false;
            this.loadData(1);
            this.$message.success(res.data);
          } else {
            this.importLoading = false;
            this.$message.error(res.data);
          }
        }).catch(() => {
          this.importLoading = false;
          this.$message.error("导入失败");
        });
      },

      //下载导入模板
      downloadModel() {
        window.open("/file/销售预测导入模版.xlsx");
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.demandStatus !== "Y") {
          return false;
        } else {
          return true;
        }
      },

      selectDeliverBill() {
        this.submitLoading = true;
        this.$http.post("basic", "salesForecasts/selectDeliverBill", null)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("新建成功");
            }
          }).finally(() => {
            this.loadData();
            this.submitLoading = false;
          });
      },

      // 打开物料选择器并记录目标行
      openAddDetail(row) {
        this.addDetailTargetRow = row;
        // 打开 MaterialSelect（组件需提供 open 方法），并传入筛选参数
        if (this.$refs.materialSelect && this.$refs.materialSelect.open) {
          this.$refs.materialSelect.open(this.materialFilter);
        }
      },

      // 接收 MaterialSelect 的选中事件（单个或数组）并追加为明细
      onMaterialSelect(selected) {
        if (!this.addDetailTargetRow) {
          this.$message.error("未指定要添加明细的行");
          return;
        }
        const toArray = (v) => (Array.isArray(v) ? v : [v]);
        const items = toArray(selected).filter(Boolean);
        if (!items.length) return;

        const materialItem = {
          materialNo: items[0].no,
          materialName: items[0].name,
          specification: items[0].zmyxh,
          earlierThreeMonthQty: 0,
          earlierTwoMonthQty: 0,
          earlierOneMonthQty: 0,
          thisMonthQty: 0,
          laterOneMonthQty: 0,
          laterTwoMonthQty: 0,
          laterThreeMonthQty: 0,
        };

        //  调用新增明细行的方法
        this.$http.post("basic", "salesForecastDetails", { masterId: this.addDetailTargetRow.pkId, ...materialItem })
          .then((resp) => {
            if (resp.success) {
              this.$message.success("新增成功");
              this.loadData();
            }
          });
        // 清空目标行引用
        this.addDetailTargetRow = null;
      },

      // 删除明细
      deleteDetailHandle(row) {
        this.$confirm("确定删除明细吗?", "提示", { type: "warning" })
          .then(() => {
            this.$http.delete("basic", "salesForecastDetails", row.itemId)
              .then((resp) => {
                if (resp.success) {
                  this.$message.success("删除成功");
                  this.loadData();
                }
              });
          })
          .catch(() => { });
      },

      submitToSap() {
        this.submitLoading = true;
        this.$http.get("basic", "salesForecasts/submitToSap")
          .then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
            }
          }).finally(() => {
            this.loadData();
            this.submitLoading = false;
          });
      },

      openApproval() {
        this.$refs.approvalDialog.open(this.selection);
      },
    },
  };
</script>
<style scoped>
.tab-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
  position: relative;
  top: -1px;
}
.tab-dot--all {
  background-color: #909399;
}
.tab-dot--approved {
  background-color: #67c23a;
}
.tab-dot--unapproved {
  background-color: #e6a23c;
}
</style>
